export default __webpack_public_path__ + "static/media/tf-banner-darken.80d8deb8.png";